import { ICON_ALERT_CIRCLE_OUTLINE } from '@doveit/bricks';
import { ContactPreviewData } from './interfaces';
import { ContactStatus } from './types';

export const MATCH_CONTACT_ERROR_MESSAGE = 'Non è stato possibile verificare l\'esistenza del contatto';
export const UPDATE_WARNING_MESSAGE = 'Cliccando il pulsante "AGGIORNA" aggiornerai il contatto selezionato con i dati in rosso.';
export const POTENTIAL_DUPLICATE_CONTACTS_MODAL_TITLE = 'Possibile contatto duplicato';
export const POTENTIAL_DUPLICATE_CONTACTS_MODAL_DESCRIPTION = 'Esistono i seguenti contatti con lo stesso numero di telefono o email. Selezionane uno dall’elenco per evitare di creare contatti duplicati, oppure continua a modificare il contatto corrente.';
export const OVERWRITE_IMPORTANT_DATA_MODAL_TITLE = 'Dati importanti sovrascritti';
export const OVERWRITE_IMPORTANT_DATA_MODAL_DESCRIPTION = 'Hai cambiato informazioni importanti (email o numero di telefono).Vuoi creare un nuovo contatto con i dati modificati o vuoi continuare a modificare il contatto corrente?';
export const DUPLICATE_CONTACT_MODAL_TITLE = 'Contatto duplicato';
export const DUPLICATE_CONTACT_MODAL_DESCRIPTION = 'Modificando il contatto, hai inserito email e telefono di un contatto esistente. Per procedere, seleziona il contatto originale.';

export const PREVIEW_HEADER_STATUS_CONFIG: Record<ContactStatus, ContactPreviewData | {}> = {
  NEW: {
    title: 'Contatto (nuovo)',
    icon: { path: ICON_ALERT_CIRCLE_OUTLINE },
    color: 'warning' as const,
  },
  MISSING_DATA:
  {
    title: 'Contatto (dati mancanti)',
    icon: { path: ICON_ALERT_CIRCLE_OUTLINE },
    color: 'critical' as const,
  },
  POTENTIAL_DUPLICATE:
  {
    title: 'Contatto (possibile duplicato)',
    icon: { path: ICON_ALERT_CIRCLE_OUTLINE },
    color: 'warning' as const,
  },
  DUPLICATE:
  {
    title: 'Contatto (duplicato)',
    icon: { path: ICON_ALERT_CIRCLE_OUTLINE },
    color: 'critical' as const,
  },
  OVERWRITE_IMPORTANT_DATA:
  {
    title: 'Contatto (dati importanti sovrascritti)',
    icon: { path: ICON_ALERT_CIRCLE_OUTLINE },
    color: 'warning' as const,
  },
  OVERWRITE_DATA:
  {
    title: 'Contatto (dati sovrascritti)',
    icon: { path: ICON_ALERT_CIRCLE_OUTLINE },
    color: 'warning' as const,
  },
  OK: {},
};
